import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";

export default function BrandMark({ variant = "dark", withText = true, withInstitution = false, className = "" }) {
  const isLight = variant === "light";
  return (
    <Link to="/" className={`inline-flex items-center gap-2.5 group ${className}`} data-testid="brand-mark">
      <span className={`inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-700 text-white shadow-md shadow-emerald-500/30 group-hover:rotate-6 transition-transform`}>
        <Leaf className="h-5 w-5" strokeWidth={2.5} />
      </span>
      {withText && (
        <div className="flex flex-col leading-tight">
          <span className={`font-cabinet font-black tracking-tight text-[15px] ${isLight ? 'text-white' : 'text-slate-900'}`}>GREENCON <span className="text-emerald-500">HPP</span></span>
          <span className={`font-outfit text-[10px] uppercase tracking-[0.2em] ${isLight ? 'text-slate-300' : 'text-slate-400'}`}>
            {withInstitution ? "Politeknik Negeri Manado" : "Beton Rendah Karbon"}
          </span>
        </div>
      )}
    </Link>
  );
}
